module.exports = __webpack_public_path__ + "static/logoParco-67769d127eb7f52e5def4a53505b71b1.png";